import { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  header?: ReactNode;
  footer?: ReactNode;
  className?: string;
}

function Card({ children, header, footer, className = '' }: CardProps) {
  return (
    <div className={`bg-white rounded-lg border border-gray-200 shadow-sm ${className}`}>
      {header && <div className="px-6 py-4 border-b border-gray-200">{header}</div>}

      <div className="px-6 py-6">{children}</div>

      {footer && <div className="px-6 py-4 border-t border-gray-200">{footer}</div>}
    </div>
  );
}

export default Card;
